import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MustMatch } from '../_helpers/must-match.validator';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import {ErrorStateMatcher} from '@angular/material/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	  const isSubmitted = form && form.submitted;
	  return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}


@Component({
  selector: 'app-retrieve',
  templateUrl: './retrieve.component.html',
  styleUrls: ['./retrieve.component.css']
})
export class RetrieveComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private route: ActivatedRoute, public _snackBar: MatSnackBar) { }
  emailForm = this.formBuilder.group({
		email: ['', [Validators.required,  Validators.email,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]] ,
  });
  passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      passwordConfirm: ['', Validators.required]
    },{
      validator: MustMatch('password', 'passwordConfirm')
    });

  public get formEmail() { return this.emailForm.controls; }
  public get formPwd() { return this.passwordForm.controls; }
  matcher = new MyErrorStateMatcher();
  token;
  result;
  errorPwd = false;
  mailSent = false;
  that = this;
  loading = false;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  ngOnInit(): void {
    this.route.queryParams.subscribe(async(params) => {
      if(params['t'])
        this.token = params['t'];
    });
  }

  async retrieve(){

    if (this.emailForm.invalid) {
			return;
    }
    this.loading = true;

    await this.http.post<String>(environment.endpoint + '/users/retrieve', {email : this.formEmail.email.value}, this.httpOptions )
                    .toPromise()
                    .then(value => {
                       this.result = value;
                    });

    if(this.result){
      this.mailSent = this.result;
    }else{
      this._snackBar.open('An error occured, try again or contact support', 'Close', {
        duration: 3000
        });
        this.loading = false;
    }
  }

  async changePwd(){
    if (this.passwordForm.invalid) {
			return;
		}
    this.loading = true;
    await this.http.post<String>(environment.endpoint + '/users/changepwd', {token: this.token, password : this.formPwd.password.value}, this.httpOptions )
      .toPromise()
      .then(value => {
        this.result = value;
      }).catch(error => {
        this.loading = false;
      });


    if(this.result){
      this._snackBar.open('Your password has been changed', 'Close', {
        duration: 8000
        });
        this.router.navigateByUrl("/login");
    }else{
      this._snackBar.open('An error occured, password has not been changed', 'Close', {
        duration: 8000
        });
        this.errorPwd = true;
        this.router.navigateByUrl('/retrieve');
    }
  }

}
